import { render } from "./FilterMainContentBox.vue?vue&type=template&id=635107f0&scoped=true"
import script from "./FilterMainContentBox.vue?vue&type=script&lang=js"
export * from "./FilterMainContentBox.vue?vue&type=script&lang=js"

import "./FilterMainContentBox.vue?vue&type=style&index=0&id=635107f0&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635107f0"]])

export default __exports__